'use client'

import { Tooltip } from '@mantine/core'
import { RiInformationLine } from '@remixicon/react'

/**
 * A small "what is this?" marker.
 *
 * Mantine's tooltip renders in a portal, which matters here: table headers sit
 * inside an `overflow-x-auto` wrapper that would otherwise clip the bubble.
 * Touch is enabled explicitly — on a phone there is no hover, and this is
 * exactly the kind of label a landlord taps to understand.
 */
export function InfoHint({ label, ariaLabel }: { label: string; ariaLabel?: string }) {
  return (
    <Tooltip
      label={label}
      multiline
      w={260}
      withArrow
      radius={8}
      color="dark"
      events={{ hover: true, focus: true, touch: true }}
      styles={{ tooltip: { fontSize: 12, lineHeight: 1.5, padding: '8px 10px' } }}
    >
      <button
        type="button"
        aria-label={ariaLabel ?? label}
        // A button (not a bare icon) so it is reachable by keyboard and by tap.
        className="inline-flex items-center justify-center text-[#98A2B3] hover:text-[#5F6369] focus:text-[#5F6369] focus:outline-none cursor-help align-middle"
      >
        <RiInformationLine className="w-3.5 h-3.5" />
      </button>
    </Tooltip>
  )
}

export default InfoHint
